import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import LeftNavGridItem from '../LeftNavGridItem';
import LeftNavListItem from '../LeftNavListItem';
import { renderIfElse } from '../../utils/helper';
const LeftMenuGroup = props => {
  const {
    cardItems,
    view,
    handleCardNavigation,
    onFavIconClick,
    title,
    icon,
    iconColor
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "leftmenugroup-container"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "leftmenugroup-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leftmenugroup-header-icon",
    style: {
      backgroundColor: "".concat(iconColor)
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "tap-icon-".concat(icon, " leftmenugroup-icon")
  }, icon === 'headset' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  })))), /*#__PURE__*/React.createElement("h4", {
    className: "leftmenugroup-title"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "leftmenugroup-body"
  }, renderIfElse(view === "list", () => cardItems.map(item => /*#__PURE__*/React.createElement(LeftNavListItem, _extends({
    card: item,
    handleCardNavigation: handleCardNavigation,
    onFavIconClick: onFavIconClick,
    view: view,
    parent: item.groupKey ? "".concat(item.groupKey) : ''
  }, props))), () => renderIfElse(view === "searchView", () => cardItems.map(item => /*#__PURE__*/React.createElement(LeftNavListItem, _extends({
    view: "searchView",
    card: item,
    handleCardNavigation: handleCardNavigation,
    onFavIconClick: onFavIconClick,
    parent: item.groupKey ? "".concat(item.groupKey) : ''
  }, props))), () => cardItems.map(item => /*#__PURE__*/React.createElement(LeftNavGridItem, _extends({
    card: item,
    handleCardNavigation: handleCardNavigation,
    onFavIconClick: onFavIconClick,
    parent: item.groupKey ? "".concat(item.groupKey) : ''
  }, props)))))));
};
export default LeftMenuGroup;